import { Chip, Grid } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import * as React from "react";
import { getApprovalInfo, getCreatedByInfo, isOpenInfo } from "../../Helper/CreateApprovelFunctions";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const InformationLabel = ({ data }) => {
  return (
    <Grid {...gridContainerProps}>
      <Chip
        key={88889999}
        color="primary"
        variant="outlined"
        label={getCreatedByInfo(data?.createdByName, data?.createdDate)}
        icon={<InfoIcon />}
      />
      {isOpenInfo(data?.acceptedDate, data?.rejectedDate) && (
        <Chip
          key={88889999}
          color="primary"
          variant="outlined"
          label={getApprovalInfo(data?.acceptedBy, data?.acceptedDate, data?.rejectedBy, data?.rejectedDate)}
          icon={<InfoIcon />}
        />
      )}
    </Grid>
  );
};

export default InformationLabel;
